import { AuthGuard, CrudOp, geometryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const GeometryView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  const brand = useRequiredProjectParam("brand");
  return (
    <AuthGuard authScope={geometryAuthScope} crudOp={CrudOp.READ} brand={brand}>
      <Suspense><LazyGeometryView projectId={projectId} subprojectId={subprojectId} brand={brand}/></Suspense>
    </AuthGuard>
  );
};

const LazyGeometryView = lazy(importView(
  () => import("../components/GeometryView"),
  (it) => it.GeometryView,
));
